import { render, staticRenderFns } from "./RentStatusMultiFamilyHouse.vue?vue&type=template&id=2ce883f2&"
import script from "./RentStatusMultiFamilyHouse.vue?vue&type=script&lang=js&"
export * from "./RentStatusMultiFamilyHouse.vue?vue&type=script&lang=js&"
import style0 from "./RentStatusMultiFamilyHouse.vue?vue&type=style&index=0&id=2ce883f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports